import { EN_TETE_VOIR_COMME, type VoirComme } from '@silex/shared';
import { useSyncExternalStore } from 'react';

/**
 * « VOIR COMME : CST / TS / SN » (F-84, 11 octobre 2026) — le choix du tuteur
 * ou de l'administrateur dans la console.
 *
 * Il vit le temps de la SESSION, en mémoire : il n'écrit rien sur un compte et
 * ne survit pas au rechargement de la page. Il part avec chaque requête, dans
 * l'en-tête `x-silex-voir-comme` ; c'est le SERVEUR qui décide s'il l'honore
 * (`sequenceRegardee`).
 */
let choix: VoirComme = 'toutes';
const abonnes = new Set<() => void>();

export const lireVoirComme = (): VoirComme => choix;

export function choisirVoirComme(valeur: VoirComme): void {
  if (valeur === choix) return;
  choix = valeur;
  for (const prevenir of abonnes) prevenir();
}

/** « Toutes » est le défaut du serveur : rien ne part. */
export function enTetesVoirComme(): Record<string, string> {
  return choix === 'toutes' ? {} : { [EN_TETE_VOIR_COMME]: choix };
}

export function useVoirComme(): VoirComme {
  return useSyncExternalStore(
    (prevenir) => {
      abonnes.add(prevenir);
      return () => abonnes.delete(prevenir);
    },
    lireVoirComme,
    lireVoirComme,
  );
}
